import { useQuery } from "react-query";
import axios from "infra/http";
import { AnexoResponse } from 'core/features/arquivo/typings/index';

function useGetArquivosCliente(id: string) {
    return useQuery(
        `/v1/cliente/${id}/arquivos`,
        async () => {
            const { data } = await axios.get<AnexoResponse[]>(
                `/v1/cliente/${id}/arquivos`
            );

            return data;
        },
        {
            enabled: !!id
        }
    );
}

export default useGetArquivosCliente;
